/* eslint-disable max-len, no-useless-escape */
import { cpf } from 'cpf-cnpj-validator';

const cpfRegex = /\d{3}[\.]?\d{3}[\.]?\d{3}[\-]?\d{2}/;

const isValidCpf = (cpfInput) => cpfRegex.test(cpfInput) && cpf.isValid(cpfInput);

export { cpfRegex, isValidCpf };
